import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import fetchUtil from '../../utils/fetchUtil';
import type { GetStaticPaths, GetStaticProps } from 'next';
import Universities from '../../components/Universities';
import { MetaTagsComp } from '../../components/MetaTagsComp';
import { CACHE_REVALIDATE } from '../../utils/constants';

// Utility function to format the country slug
const formatCountrySlug = (slug: string) => {
  let formattedSlug = slug
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
  if (formattedSlug === 'Usa') {
    formattedSlug = 'USA';
  } else if (formattedSlug === 'Uk') {
    formattedSlug = 'UK';
  }
  return formattedSlug;
};

const CountryUniversities: React.FC = (props: any) => {
  const router = useRouter();
  const { country } = router.query;

  useEffect(() => {
    const customStyle = document.documentElement.style;
    customStyle.setProperty('--navbar-color', '#313145');
    customStyle.setProperty('--navbar-menu-color', '#ffff');
  }, []);

  const countrySlug = country as string;
  const pageNumber = 'page-1';
  const formattedCountrySlug = formatCountrySlug(countrySlug);
  
  const countryMeta = props.universityCountries.find(
    (country: any) => country.label === formattedCountrySlug
  )?.meta;

  return (
    <>
      {countryMeta && <MetaTagsComp {...countryMeta} />}
      <Universities
        {...props}
        countrySlug={countrySlug}
        pageNumber={pageNumber}
      />
    </>
  );
};

export const getStaticPaths: GetStaticPaths = async () => {
  return { 
    paths: [], 
    fallback: 'blocking'
  };
};

export const getStaticProps: GetStaticProps = async (context) => {
  let pageData;
  let universityCountries;
  let countryFaqsData;

  try {
    pageData = await fetchUtil(
      `${process.env.NEXT_PUBLIC_API_BASE_URL}/universities-landing`,
      'GET',
      {},
      '',
      false
    );
  } catch (error) {
  }

  try {
    universityCountries = await fetchUtil(
      `${process.env.NEXT_PUBLIC_API_BASE_URL}/university-countries?_sort=priority`,
      'GET',
      {},
      '',
      false
    );
  } catch (error) {
  }

  try {
    countryFaqsData = await fetchUtil(
      `${process.env.NEXT_PUBLIC_API_BASE_URL}/university-countries-faqs`,
      'GET',
      {},
      '',
      false
    );
  } catch (error) {
  }

  return {
    props: {
      pageData: pageData || null,
      universityCountries: universityCountries || null,
      countryFaqsData: countryFaqsData || null,
    },
    revalidate: CACHE_REVALIDATE
  };
};

export default CountryUniversities; 